module.exports = __webpack_public_path__ + "img/EME_titlelogo_EOK.a9becac4.png";